import React, { Context, createContext, ReactElement, ReactNode, useState } from 'react'
import { ReactState, StateSetter } from '../Types/Types'

export type ModalContextType = {
    popoutMode?: boolean
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    closeModal: (...arg: any[]) => void
    popoutFunc?: () => void
    setModalTitle?: StateSetter<string>
}

export type ModalContextOutputType = ModalContextType & {
    disablePopoutOption: boolean
    setDisablePopoutOption: StateSetter<boolean>
}

type Props = {
    modalInput: ModalContextType
    children: ReactNode
}

/**
 * Make call modal context to pass the closeModal around.
 *
 * @param closeModal - The close modal function to pass around.
 */
export const ModalContextProvider: React.FC<Props> = ({ modalInput, children }: Props): ReactElement => {
    const [disablePopoutOption, setDisablePopoutOption]: ReactState<boolean> = useState<boolean>(true)

    return (
        <ModalContext.Provider
            value={{
                ...modalInput,
                setDisablePopoutOption,
                disablePopoutOption
            }}
        >
            {children}
        </ModalContext.Provider>
    )
}

export const ModalContext: Context<ModalContextOutputType> = createContext<ModalContextOutputType>({
    popoutMode: false,
    // Intentionally empty function.
    // eslint-disable-next-line
    closeModal: (): void => {},
    disablePopoutOption: false,
    // Intentionally empty function.
    // eslint-disable-next-line
    setDisablePopoutOption: (): void => {},
})
